import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { GetUserCountDto } from "../../../models/analytics/dto/get-user-count.dto";

export const GET_USER_COUNT_QUERY_KEY = 'userCount';

export const useGetUserCount = (organizationId: string, startDate?: Date, endDate?: Date) => {
    const apiClient = useApiClient();
    return useQuery<GetUserCountDto>({
        queryKey: [GET_USER_COUNT_QUERY_KEY, organizationId, startDate, endDate],
        queryFn: async () => {
            const dateSuffix = startDate && endDate ? `&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}` : '';
            return apiClient.fetchApi<GetUserCountDto, {}>({ method: 'GET', endpoint: `analytics/user-count?organizationId=${organizationId}${dateSuffix}` });
        },
        enabled: !!organizationId,
        staleTime: 5 * 60 * 1000,
    });
}
